import { render, staticRenderFns } from "./PLIPrestadores.vue?vue&type=template&id=3d3663a9&scoped=true&"
import script from "./PLIPrestadores.vue?vue&type=script&lang=js&"
export * from "./PLIPrestadores.vue?vue&type=script&lang=js&"
import style0 from "./PLIPrestadores.vue?vue&type=style&index=0&id=3d3663a9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d3663a9",
  null
  
)

export default component.exports